import React from 'react';
import { Typography } from '@naf-simba/building-blocks-typography';
import ReadMoreButton from '@components/ReadMoreButton/ReadMoreButton';
import { Consent } from '../../../../../types/Consents';
import * as S from './ConsentContent.styles';

interface ConsentContentProps {
  consent: Consent;
  consentSelectItem: JSX.Element;
  onReadMoreToggle: () => void;
  isReadMoreActive: boolean;
}

const ConsentContent = ({ consent, consentSelectItem, onReadMoreToggle, isReadMoreActive }: ConsentContentProps) => (
  <S.ConsentWrapper>
    <S.ConsentTextWrapper>
      <S.ConsentTextContent>
        <S.ConsentStatementText variant="titleS">{consent.statement.statement}</S.ConsentStatementText>
        {consent.statement.description && <Typography variant="paragraphS">{consent.statement.description}</Typography>}
        {consent.statement.helpText && (
          <S.ReadMoreButtonMobileDesktop>
            <ReadMoreButton onToggle={onReadMoreToggle} isActive={isReadMoreActive} />
          </S.ReadMoreButtonMobileDesktop>
        )}
        {isReadMoreActive && consent.statement.helpText && (
          <S.ConsentHelpText variant="paragraphS">{consent.statement.helpText}</S.ConsentHelpText>
        )}
      </S.ConsentTextContent>
      {consent.statement.helpText && (
        <S.ReadMoreButtonWrapperDesktop>
          <ReadMoreButton onToggle={onReadMoreToggle} isActive={isReadMoreActive} />
        </S.ReadMoreButtonWrapperDesktop>
      )}
    </S.ConsentTextWrapper>
    {consentSelectItem}
  </S.ConsentWrapper>
);

export default ConsentContent;
